<template>
  <div class="absences-container">

    <div class="header">
      <div class="left-section">
        <button @click="navigateTo('main')" class="btn-volver">
          <AppIcon :src="require('@/modules/working_hours/assets/keyboard_backspace.svg')" :size="29" class="icono-btn-secu" />
          Vista general
        </button>
        <h1 class="page-title">Gestión de Vacaciones</h1>
      </div>

      <div class="right-section">
        <v-btn
          rounded
          class="add-absence-btn"
          :loading="screen_data.ui_loading"
          @click="screen_data.create_absence_cmd.execute()"
        >
          <AppIcon :src="require('@/modules/working_hours/assets/event.svg')" :size="29" class="icono-btn-secu" />
          Vacaciones
        </v-btn>

        <button
          @click="loadClocks"
          class="btn-primario btn-refresh"
          :disabled="screen_data.ui_loading"
        >
          <AppIcon :src="require('@/modules/working_hours/assets/refresh.svg')" :size="29" class="icono-btn" />
        </button>

      </div>
    </div>
    <hr class="header-separator" />

      <div class="acciones-secundarias">
        <button @click="navigateTo('absences')" class="btn-secundario-1">
          Ausencias
        </button>
        <button @click="navigateTo('history')" class="btn-secundario-1">
          Historial
        </button>
        <button @click="navigateTo('admin-month')" class="btn-secundario-1">
          Previsualización mes
        </button>
        <button @click="navigateTo('holidays')" class="btn-secundario">
          Vacaciones
        </button>
        <button
          v-if="canViewAdminButton"
          @click="navigateToAdmin"
          class="btn-secundario-1"
        >
          Admin
        </button>
      </div>
    <hr class="header-separator-1" />


    <div class="main-content">
      <!-- Widget de estadísticas de vacaciones -->
      <div class="vacation-stats-widget">
        <div class="stats-header">
          <h3 class="stats-title">Resumen de Vacaciones</h3>
        </div>
        <div class="stats-body">
          <div class="stat-item">
            <div class="stat-icon total">
              <v-icon color="white">mdi-calendar-check</v-icon>
            </div>
            <div class="stat-content">
              <div class="stat-label">Días Totales</div>
              <div class="stat-value">{{ vacationStats.totalDays }} días</div>
            </div>
          </div>

          <div class="stat-item">
            <div class="stat-icon used">
              <v-icon color="white">mdi-calendar-remove</v-icon>
            </div>
            <div class="stat-content">
              <div class="stat-label">Días Usados</div>
              <div class="stat-value">{{ vacationStats.usedDays }} días</div>
            </div>
          </div>

          <div class="stat-item">
            <div class="stat-icon remaining">
              <v-icon color="white">mdi-calendar-clock</v-icon>
            </div>
            <div class="stat-content">
              <div class="stat-label">Días Restantes</div>
              <div class="stat-value remaining-highlight">{{ vacationStats.remainingDays }} días</div>
            </div>
          </div>
        </div>
      </div>

      <div class="content-row">
        <div class="calendar-section">
          <div class="calendar-nav">
            <v-btn icon @click="prevMonth"><v-icon>mdi-chevron-left</v-icon></v-btn>
            <div class="month-title">{{ monthName }} {{ currentYear }}</div>
            <v-btn icon @click="nextMonth"><v-icon>mdi-chevron-right</v-icon></v-btn>
          </div>

          <table class="calendar glass-calendar">
            <thead>
              <tr>
                <th v-for="(day, i) in screen_data.weekDays" :key="i">{{ day }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(week, i) in screen_data.calendar" :key="i">
                <td
                  v-for="(day, j) in week"
                  :key="j"
                  class="calendar-cell"
                  :class="{ today: day.isToday }"
                  @click="day.date && openCreatePopup(day.date)"
                >
                  <div v-if="day.day" class="day-number">{{ day.day }}</div>
                  <div v-if="day.hasAbsence" class="holiday-dot" :class="{
                    'holiday-dot-approved': day.absenceStatus === 'approved',
                    'holiday-dot-pending': day.absenceStatus === 'pending' || day.absenceStatus === 'mixed',
                    'holiday-dot-rejected': day.absenceStatus === 'rejected'
                  }"></div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="absence-widget">
        <div class="widget-header">
          <p class="widget-title">Vacaciones solicitadas</p>
        </div>
          <div class="widget-body">
            <div v-if="filteredAbsences.length" class="widget-list-scroll">
              <ul class="widget-list">
                <li v-for="absence in filteredAbsences" :key="absence.id" class="widget-item">
                  <div class="card-content">
                    <div class="card-center">
                      <div class="info-row">
                      </div>
                      <div class="info-row">
                        <div class="info-item full-width">
                          <span class="info-label">Motivo:</span>
                          <span class="info-value">{{ absence.reason || 'Sin especificar' }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="card-right">
                      <div class="date-time-column">
                        <div class="date-time-item">
                          <span class="info-label">Desde</span>
                          <span class="info-value">{{ formatOnlyDate(absence.start) }}</span>
                        </div>
                        <div class="date-time-item">
                          <span class="info-label">Hasta</span>
                          <span class="info-value">{{ formatOnlyDate(absence.end) }}</span>
                        </div>
                      </div>

                      <div class="status-container">
                        <div
                          class="status-badge-new"
                          :class="{
                            'badge-approved': absence.status === 'approved',
                            'badge-pending': absence.status === 'pending',
                            'badge-rejected': absence.status === 'rejected'
                          }"
                        >
                          {{ absence.status === 'pending' ? 'Pendiente' : absence.status === 'approved' ? 'Aprobado' : 'Rechazado' }}
                          <span
                            class="status-indicator"
                            :class="{
                              'indicator-approved': absence.status === 'approved',
                              'indicator-pending': absence.status === 'pending',
                              'indicator-rejected': absence.status === 'rejected'
                            }"
                          ></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div v-else class="no-absence">
              Durante el mes, no se registraron vacaciones solicitadas.
            </div>
          </div>
        </div>
      </div>
    </div>
<!-- <button @click.stop="openUpdatePopup(absence)">Modificar</button> NO SE SI QUEREMOS QUE HAGAN ESO--> 

    <UpdateHolidayPopup
      v-if="screen_data.create_absence_popup && screen_data.create_absence_popup.showed"
      :show="screen_data.create_absence_popup.showed"
      :holiday="screen_data.create_absence_popup.absence_data || null"
      :preselected-date="screen_data.create_absence_popup.preselected_date"
      :existing-holidays="screen_data.absences"
      :errors="screen_data.create_absence_popup.errors"
      :key="screen_data.create_absence_popup.absence_data ? screen_data.create_absence_popup.absence_data.id || 'new' : 'new'"
      @close="close_create_absence_popup"
      @update-errors="onUpdateErrors"
    />

    <!-- Snackbar para mensajes de error/éxito -->
    <v-snackbar
      v-model="snackbar.visible"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      top
      right
    >
      <b>{{ snackbar.text }}</b>
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="snackbar.visible = false"
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { APIAbsenceRepository } from "./APIAbsenceRepository";
import { VueUpdateAbsencePopup } from "@/modules/working_hours/infra/VueUpdateAbsencePopup";
import UpdateHolidayPopup from "@/modules/working_hours/infra/UpdateHolidayPopup.vue";
import { LoadAbsence } from "@/modules/working_hours/app/LoadAbsence";
import { CalendarAbsence } from "../app/CalendarAbsences";
import { CreateAbsenceCommand } from "@/modules/working_hours/app/CreateAbsenceCommand";
import { UpdateAbsenceCommand } from "@/modules/working_hours/app/UpdateAbsenceCommand";
import { CreateAbsencePopup } from "@/modules/working_hours/domain/CreateAbsencePopup";
import { formatDate } from '@/modules/working_hours/domain/Utils';
import { CalendarAbsencesUseCase } from "@/modules/working_hours/app/CalendarAbsencesUseCase";
import { query_dispatcher } from '@/api/client';

export default {
  components: { UpdateHolidayPopup },
  props: {
    companydb_id: {
      type: String,
      default: null
    }
  },
  data() {
    const today = new Date();
    return {
      screen_data: {
        absences: [],
        create_absence_popup: null,
        create_absence_cmd: null,
        ui_loading: false,
        update_popup: new VueUpdateAbsencePopup(),
        currentMonth: today.getMonth(),
        currentYear: today.getFullYear(),
        calendar: [],
        weekDays: ["L", "M", "X", "J", "V", "S", "D"],
        showSnackbar: null, // Se asignará en mounted
      },
      loadAbsence: null,
      createAbsenceCommand: null,
      vacationDaysTotal: 22, // valor por defecto
      snackbar: {
        visible: false,
        text: '',
        color: 'error',
        timeout: 4000
      }
    };
  },
  
  async mounted() {
    const absenceRepo = new APIAbsenceRepository();
    this.screen_data.create_absence_popup = new CreateAbsencePopup();

    // Asignar el método showSnackbar al screen_data
    this.screen_data.showSnackbar = this.showSnackbar;

    this.screen_data.create_absence_cmd = new CreateAbsenceCommand(absenceRepo, this.screen_data);
    this.loadAbsence = new LoadAbsence(absenceRepo, this.screen_data);

    await this.loadAbsence.load(this.currentUserId);
    await this.loadVacationDays();
    this.updateCalendar();

    this.createAbsenceCommand = this.screen_data.create_absence_cmd;
  },

  computed: {
    monthName() {
      const date = new Date(this.currentYear, this.currentMonth);
      return (
        date.toLocaleDateString("es-ES", { month: "long" })
          .charAt(0).toUpperCase() +
        date.toLocaleDateString("es-ES", { month: "long" }).slice(1)
      );
    },

    filteredAbsences() {
      if (!this.loadAbsence) return [];
      const allAbsences = this.loadAbsence.filterAbsencesByMonth(this.currentMonth, this.currentYear);
      // Filtrar solo las que tienen tipo "Vacaciones"
      return allAbsences.filter(absence => absence.tipoAusencia === 'Vacaciones');
    },

    vacationStats() {
      const approvedVacations = this.screen_data.absences.filter(
        absence => absence.tipoAusencia === 'Vacaciones' && absence.status === 'approved'
      );

      let usedDays = 0;
      for (const vacation of approvedVacations) {
        const startDate = new Date(vacation.start);
        const endDate = new Date(vacation.end);

        // Calcular días entre fechas (inclusive)
        const diffTime = Math.abs(endDate - startDate);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
        usedDays += diffDays;
      }

      const remainingDays = Math.max(0, this.vacationDaysTotal - usedDays);

      return {
        totalDays: this.vacationDaysTotal,
        usedDays: usedDays,
        remainingDays: remainingDays
      };
    },

    canViewAdminButton() {
      const userData = this.$store.getters['me/userData'];
      if (!userData) return false;

      const userRole = userData.user_role ? userData.user_role.value : null;
      return userRole === 'owner' || userRole === 'admin' || userRole === 'customer';
    },

    currentUserId() {
      const userData = this.$store.getters['me/userData'];
      return userData ? userData.id : null;
    },

    currentMonth: {
      get() {
        return this.screen_data.currentMonth;
      },
      set(value) {
        this.screen_data.currentMonth = value;
      },
    },
    currentYear: {
      get() {
        return this.screen_data.currentYear;
      },
      set(value) {
        this.screen_data.currentYear = value;
      },
    },
  },

  watch: {
    companydb_id: async function (newVal, oldVal) {
      if (newVal !== oldVal) {
        await this.$router.push({
          name: 'working-hours-holidays',
          params: { companydb_id: newVal }
        }).catch(() => {});
        // Recargar los datos con la nueva empresa
        if (this.loadAbsence) {
          await this.loadAbsence.load(this.currentUserId);
          this.updateCalendar();
        }
      }
    }
  },

  methods: {
    async loadVacationDays() {
      try {
        const userData = this.$store.getters['me/userData'];
        const userId = userData && userData.user ? userData.user : userData.id;

        if (!userId) {
          console.warn('No user ID found');
          return;
        }

        const result = await query_dispatcher.dispatch('get_work_schedule_by_user.query', {
          user_id: userId
        });

        if (result && result.vacation_days) {
          this.vacationDaysTotal = result.vacation_days;
        }
      } catch (error) {
        console.error('Error loading vacation days:', error);
        // Mantener el valor por defecto de 22 días
      }
    },

    showSnackbar(color, text) {
      this.snackbar.text = text;
      this.snackbar.color = color;
      this.snackbar.visible = true;
    },
    getCompanyId() {
      return this.companydb_id || this.$route.params.companydb_id || (this.$store.getters["me/userData"] && this.$store.getters["me/userData"].company_id) || "1";
    },
    navigateTo(section) {
      const companyId = this.getCompanyId();
      const routes = {
        "main": `/${companyId}/working-hours`,
        "absences": `/${companyId}/working-hours-absences`,
        "history": `/${companyId}/working-hours-history`,
        "admin-month": `/${companyId}/working-hours-admin-month`,
        "holidays": `/${companyId}/working-hours-holidays`,
        "admin-users": `/${companyId}/working-hours-admin-users`
      };
      var result = this.$router.push(routes[section]);
      if (result && result.catch) {
        result.catch(function() {});
      }
    },
    navigateToAdmin() {
      // Todos (owner, admin, cliente) van a working-hours-admin-users
      this.navigateTo('admin-users');
    },
    async close_create_absence_popup(absence) {
      this.screen_data.create_absence_popup.close(absence);
      if (absence) {
        await this.loadAbsence.load(this.currentUserId);
        this.updateCalendar();
      }
    },
  
    async onJustificanteSelected(event, absence) {
      const file = event.target.files[0];
      if (!file) return;

      absence.justificante = file;

      const cmd = new UpdateAbsenceCommand(new APIAbsenceRepository(), this.screen_data);
      await cmd.execute({ ...absence, justificante: file });

      const userData = this.$store.getters['me/userData'];
        const userId = userData && userData.user ? userData.user : userData.id;
        await this.loadAbsence.load(userId);
      this.updateCalendar();
    },

    goBack() {
      this.navigateTo('main');
    },

    async loadClocks() {
      this.screen_data.ui_loading = true;
      try {
        await this.loadAbsence.load(this.currentUserId);
        await this.loadVacationDays(); // Recargar días de vacaciones
        this.updateCalendar();
      } finally {
        this.screen_data.ui_loading = false;
      }
    },

    formatDate(dateStr) {
      return formatDate(dateStr);
    },

    formatTime(dateStr) {
      const date = new Date(dateStr);
      return `${String(date.getHours()).padStart(2,'0')}:${String(date.getMinutes()).padStart(2,'0')}`;
    },

    formatOnlyDate(dateStr) {
      const date = new Date(dateStr);
      // Usar métodos UTC para evitar problemas de zona horaria
      const day = String(date.getUTCDate()).padStart(2, '0');
      const month = String(date.getUTCMonth() + 1).padStart(2, '0');
      const year = date.getUTCFullYear();
      return `${day}/${month}/${year}`;
    },

    async openUpdatePopup(absence) {
      const updated = await this.screen_data.update_popup.show(absence);
      if (updated) {
        await this.loadAbsence.load(this.currentUserId);
      }
    },
    async addAbsence() {
      const created = await this.screen_data.create_absence_popup.show();
      if (created) {
        await this.loadAbsence.load(this.currentUserId);
      }
    },
    closeUpdatePopup() {
      this.screen_data.update_popup.close();
    },
    updateCalendar() {
      // Filtrar solo las vacaciones (tipo "Vacaciones") para mostrar en el calendario
      const vacaciones = this.screen_data.absences.filter(absence => absence.tipoAusencia === 'Vacaciones');

      this.screen_data.calendar = CalendarAbsence(
        this.screen_data.currentYear,
        this.screen_data.currentMonth,
        vacaciones
      );

      const today = new Date();
      this.screen_data.calendar.forEach(week => {
        week.forEach(day => {
          if (day.date) {
            const d = new Date(day.date);
            day.isToday =
              d.getDate() === today.getDate() &&
              d.getMonth() === today.getMonth() &&
              d.getFullYear() === today.getFullYear();
          }
        });
      });
    },

    nextMonth() { 
      if (this.currentMonth === 11) {
        this.currentMonth = 0;
        this.currentYear++;
      } else {
        this.currentMonth++;
      }
      this.updateCalendar();
    },

    prevMonth() { 
      if (this.currentMonth === 0) {
        this.currentMonth = 11;
        this.currentYear--;
      } else {
        this.currentMonth--;
      }
      this.updateCalendar();
    },

// Agregar estos métodos a tu componente Vue principal

    async openCreatePopup(date) {
      
      if (this.createAbsenceCommand) {
        try {
          // Convertir la fecha string a Date object si es necesario
          const selectedDate = typeof date === 'string' ? new Date(date) : date;
          await this.createAbsenceCommand.openCreatePopup(selectedDate);
          // Recargar datos si fue exitoso
          await this.loadAbsence.load(this.currentUserId);
          this.updateCalendar();
        } catch (error) {
        }
      } else {
      }
    },

    async close_create_absence_popup(absence) {
      this.screen_data.create_absence_popup.close(absence);
      if (absence) {
        await this.loadAbsence.load(this.currentUserId);
        this.updateCalendar();
      }
    },

    onUpdateErrors(errors) {
      this.screen_data.create_absence_popup.setErrors(errors);
    },
  }
};
  
</script>

<style scoped>

.absences-container {
  background-color: #FFFFFF;
  height: calc(100vh - 60px);
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  overflow-y: auto;
  border-radius: 20px 20px 0 0;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;       
  width: 100%;
  margin-bottom: 4px;
}

.left-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 4px;
}

.back-btn {
  margin-right: 12px;
  color: #fff
}

.page-title {
  margin-top: 2px;
  margin-left: 20px;
  font-size: 17px;
  font-weight: 600;
  color: var(--v-primaryDark-base);
}

.add-absence-btn {
  display: flex !important;
  width: 140px !important;
  height: 30px !important;
  padding: 6px !important;
  justify-content: center !important;
  align-items: center !important;
  gap: 6px !important;

  border-radius: 8px !important;
  border: 1px solid var(--Primary-800, var(--v-primary-base)) !important;
  background: var(--Primary-50, #F9F6FE) !important;

  color: var(--v-primary-base) !important;
  font-weight: 600;
  font-size: 11px;
  text-transform: none;
  box-shadow: none !important;
}

.history-section {
  margin-bottom: 30px;
}

.section-title {
  font-size: 18px;
  font-weight: 500;
  color: #555;
  margin-bottom: 10px;
}

.absence-list {
  list-style: none;
  padding: 0;
}

.absence-item {
  padding: 12px;
  border-radius: 8px;
  background-color: var(--v-neutral-base);
  font-size: 14px;
  color: #1C1B1F;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 6px rgba(0,0,0,0.03);
}

.reason {
  font-size: 13px;
  color: #8E24AA;
  margin-left: 8px;
}

.calendar-nav {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 12px;
}

.month-title {
  font-weight: 500;
  font-size: 14px;
  margin: 0 12px;
  color: #454545;
}

.calendar {
  width: 100%;
  border-collapse: collapse;
  text-align: center;
  border-radius: 16px;
  overflow: hidden;
}

.calendar th,
.calendar td {
  width: 14.2%;
  height: 60px;
  border: 1px solid transparent;
  vertical-align: top;
  padding: 4px;
  position: relative;
  font-size: 12px;
  color: #fff;
}

.calendar th {
  font-weight: 500;
  color: #454545;
}

.glass-calendar {
  background-color: var(--v-neutral-base); 
  border: 1px solid #E1D7F1;
  border-radius: 12px;
}

.day-number {
  font-size: 13px;
  font-weight: 500;
  color: #454545;
}

.holiday-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin: 4px auto 0 auto;
  border: 2px solid transparent;
}

.holiday-dot-approved {
  background-color: #10b981;
  border-color: #8E24AA;
}

.holiday-dot-pending {
  background-color: #f59e0b;
  border-color: #8E24AA;
}

.holiday-dot-rejected {
  background-color: #8E24AA;
  border-color: #8E24AA;
}

.calendar-cell {
  cursor: pointer;
  transition: background-color 0.2s;

}

.calendar-cell:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.btn-volver {
  display: flex;
  align-items: center;
  color: var(--Neutral-300, #B0B0B0);
  font-family: Roboto;
  font-size: 11px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px 14px;
  border-radius: 4px;
  width: 400px;
  height: 16px;
  flex-shrink: 0;
}

.icono-btn-secu {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.right-section {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-separator {
  width: 100%;
  border: none;
  border-top: 1px solid #ccc;
  margin: 0;
}

.header-separator-1 {
  width: 100%;
  border: none;
  border-top: 1px solid #ccc;
  margin: 0;
}

.acciones-secundarias {
  display: flex;
  justify-content: flex-start;
  gap: 8px;
  width: 100%;
  margin: 12px 0;
  padding: 0 12px;
  box-sizing: border-box;
}

.btn-secundario-1 {
  display: flex;
  width: auto;
  height: 26px;
  padding: 6px 12px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  border-radius: 8px;
  border: 1px solid var(--Neutral-200, #D1D1D1);
  background: var(--Neutral-150, #F3F3F3);
  color: #666;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s ease;
}

.btn-secundario-1:hover {
  background: #ECECEC;
}

.btn-secundario {
  display: flex;
  width: 150px;
  height: 26px;
  padding: 6px 12px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  border-radius: 8px;
  border: 1px solid var(--Neutral-200, #D1D1D1);
  background: var(--Neutral-150, #E7E7E7);
  color: #333;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
}

.main-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
  padding: 8px 12px 0;
  box-sizing: border-box;
}

.vacation-stats-widget {
  width: 100%;
  background-color: var(--v-neutral-base);
  border-radius: 10px;
  padding: 14px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}

.stats-header {
  margin-bottom: 10px;
}

.stats-title {
  font-size: 14px;
  font-weight: 600;
  color: #6D6D6D;
  margin: 0;
}

.stats-body {
  display: flex;
  gap: 12px;
  justify-content: space-around;
  flex-wrap: wrap;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  background: white;
  border-radius: 10px;
  flex: 1;
  min-width: 180px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
  transition: transform 0.2s, box-shadow 0.2s;
}

.stat-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.stat-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.stat-icon.total {
  background: linear-gradient(135deg, #7339B7 0%, #9F6BE1 100%);
}

.stat-icon.used {
  background: linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%);
}

.stat-icon.remaining {
  background: linear-gradient(135deg, #10b981 0%, #34d399 100%);
}

.stat-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.stat-label {
  font-size: 11px;
  color: #888;
  font-weight: 500;
}

.stat-value {
  font-size: 18px;
  font-weight: 700;
  color: #333;
}

.stat-value.remaining-highlight {
  color: #10b981;
}

.content-row {
  display: flex;
  gap: 20px;
  width: 100%;
}

.calendar-section {
  flex: 2;
  background-color: var(--v-neutral-base);
  border-radius: 10px;
  padding: 10px;
  box-shadow: 0 0px 12px rgba(0,0,0,0.08);
  min-height: 300px;
}

.calendar th,
.calendar td {
  height: 35px;
  font-size: 11px;
  padding: 2px;
}

.absence-section {
  flex: 2;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background-color: #FFFFFF;
  border-radius: 10px;
  padding: 10px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
}

.absence-widget {
  flex: 4;
  max-height: 380px;
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  background-color: var(--v-neutral-base);
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  overflow: hidden;
  min-height: 300px;
}

.widget-header {
  padding: 8px 12px;
  background-color: var(--v-neutral-base);
  border-bottom: 1px solid #E7E7E7;
}

.today .day-number {
  background-color: #9F6BE1;
  color: #fff;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  margin: 0 auto;
  line-height: 1;
}

.widget-title {
  font-size: 14px;
  font-weight: 600;
  color: #6D6D6D;
  margin: 0;
}

.widget-body {
  flex: 1;
  overflow-y: auto;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.widget-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.widget-item {
  background: white;
  border-radius: 10px;
  padding: 14px 18px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s, box-shadow 0.2s;
  font-size: 12px;
  color: #1C1B1F;
}

.card-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.card-center {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.info-row {
  display: flex;
  gap: 24px;
  align-items: center;
}

.info-item {
  display: flex;
  gap: 8px;
  align-items: baseline;
}

.info-item.full-width {
  flex: 1;
}

.info-label {
  color: #6b7280;
  font-size: 12px;
  font-weight: 600;
}

.info-value {
  color: #374151;
  font-size: 12px;
  font-weight: 500;
}

.info-value-accent {
  color: #7339B7;
  font-size: 13px;
  font-weight: 600;
}

.card-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.date-time-column {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.date-time-item {
  display: flex;
  gap: 8px;
  align-items: baseline;
}

.status-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.status-badge-new {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 16px;
  border: 2px solid;
  font-size: 11px;
  font-weight: 600;
}

.status-badge-new.badge-approved {
  border-color: #10b981;
  color: #10b981;
  background: #d1fae5;
}

.status-badge-new.badge-pending {
  border-color: #f59e0b;
  color: #f59e0b;
  background: #fef3c7;
}

.status-badge-new.badge-rejected {
  border-color: #ef4444;
  color: #ef4444;
  background: #fee2e2;
}

.status-indicator {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.status-indicator.indicator-approved {
  background: #10b981;
}

.status-indicator.indicator-pending {
  background: #f59e0b;
}

.status-indicator.indicator-rejected {
  background: #ef4444;
}

.no-absence {
  color: var(--Neutral-500, #6D6D6D);
  text-align: center;
  font-family: var(--Static-Title-Small-Font, Roboto);
  font-size: var(--Static-Title-Small-Size, 12px);
  font-style: normal;
  font-weight: 500;
  line-height: var(--Static-Title-Small-Line-Height, 20px);

  display: flex;
  justify-content: center; 
  align-items: center;    
  height: 100%;           
}

.widget-list-scroll {
  max-height: 380px;
  overflow-y: auto;
}

@media (max-width: 768px) {
  .absences-container {
    padding: 16px;
  }

  .header {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    margin-bottom: 16px;
  }

  .left-section {
    width: 100%;
  }

  .right-section {
    width: 100%;
    justify-content: flex-end;
    gap: 16px;
  }

  .btn-volver {
    width: 100%;
    justify-content: flex-start;
  }

  .page-title {
    margin-left: 0;
    font-size: 15px;
  }

  .acciones-secundarias {
    justify-content: center;
    padding: 0;
    margin: 16px 0 0 0;
  }

  .mobile-add-btn {
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 16px 0;
  }

  .add-absence-btn {
    width: 200px !important;
    margin: 0 auto;
  }

  .main-content {
    flex-direction: column;
    gap: 0px;
    padding: 0;
  }

  .calendar-section {
    flex: none;
    width: 100%;
    order: 1;
  }

  .absence-widget {
    flex: none;
    width: 100%;
    min-height: 300px;
    max-height: 400px;
    order: 2;
  }

  .calendar th,
  .calendar td {
    height: 35px;
    font-size: 11px;
  }

  .day-number {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .page-title {
    font-size: 14px;
  }

  .add-absence-btn {
    width: 100% !important;
    max-width: 280px !important;
  }

  .calendar th,
  .calendar td {
    height: 30px;
    font-size: 10px;
    padding: 1px;
  }

  .day-number {
    font-size: 12px;
  }

  .today .day-number {
    width: 24px;
    height: 24px;
  }

  .widget-item {
    padding: 16px 20px;
  }

  .card-content {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }

  .card-center {
    order: 2;
  }

  .card-right {
    order: 3;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
    gap: 12px;
  }

  .date-time-column {
    order: 1;
    width: 100%;
  }

  .status-container {
    order: 3;
    width: 100%;
    justify-content: space-between;
  }

  .info-row {
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
  }
}

</style>
